import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslations } from "use-intl";

import { Skeleton } from "@lawline/ui/components/skeleton";

import { adminTenantsQueryOptions } from "./tenants.queries";
import { TenantsTable } from "./components/tenants-table";
import { TableSearch } from "@platform/components/ui/table-search";

export function AdminTenantsPage() {
	const t = useTranslations("admin.tenants");
	const { data: tenants, isPending, error } = useQuery(adminTenantsQueryOptions);
	const [query, setQuery] = useState("");

	const q = query.trim().toLowerCase();
	const visible = q
		? (tenants ?? []).filter(
				(o) => o.name.toLowerCase().includes(q) || (o.slug?.toLowerCase().includes(q) ?? false),
			)
		: (tenants ?? []);

	return (
		<section className="mx-auto mt-2 flex w-full max-w-3xl flex-col gap-6">
			<h1 className="text-2xl font-semibold">{t("title")}</h1>

			{isPending ? (
				<Skeleton className="h-24 w-full" />
			) : error ? (
				<p className="text-destructive text-sm">{t("error")}</p>
			) : (
				<div className="flex flex-col gap-3">
					<TableSearch value={query} onChange={setQuery} placeholder={t("searchPlaceholder")} />
					<TenantsTable tenants={visible} />
				</div>
			)}
		</section>
	);
}
